import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { OrchestratedQueriesComposite } from "@/domains/diagnostics/orchestrated-queries/components/composables/orchestrated-queries-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"

export default function OrchestratedQueriesPage() {
  return (
    <PageContainer>
      <MetaData title="Orchestrated Query Diagnostics" />
      <PageTitle
        title="Orchestrated Query Diagnostics"
        items={[
          createBreadcrumbItem("more", "More", "/"),
          createBreadcrumbItem("diagnostics", "Diagnostics", "/diagnostics"),
          createBreadcrumbItem(
            "orchestrated-queries",
            "Orchestrated Queries",
            "/diagnostics/orchestrated-queries",
            true,
          ),
        ]}
      />
      <OrchestratedQueriesComposite />
    </PageContainer>
  )
}
